/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/react-in-jsx-scope */
import { Modal } from '@mui/material';
import { SVGBank, SVGCardPayment, SVGCash, SVGCheckActive, SVGQrCode, SVGUpDown } from 'assets/svg';
import MyButton from 'components/Button.tsx';
import CheckBox from 'components/CheckBox';
import DropDownComponent from 'components/DropDown';
import { TableDropDown } from 'components/DropDown/types';
import { MyTextAreaInput } from 'components/TextAera';
import { TextAreaActions } from 'components/TextAera/types';
import { OptionPaymentType, VoucherType } from 'constants/Defines';
import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { Language } from 'shared/Language';
import Format from 'utils/Format';
import Box from '@mui/material/Box';
import * as enpoint from '../../../api/endpoints';
import { ListDropsDown, ParamsPayment, PopupPaymentActions, PopupPaymentProps } from './types';
import { fetchCityInfo, fetchGenQr, fetchInfoPrintOrder, fetchListRoom, fetchListSource, fetchOrderDetail, fetchPayment, fetchRoomInfo, fetchUpdateDiscountOrder, fetchUpdateUpdateVATAndSVC, fetchVoucher, removeVoucher } from 'service/orderService';
import { TYPE_EXTEMP, TYPE_INPUT, TYPE_SOURCE } from 'constants/AppEnums';
import LoadingTable from 'components/LoadingTable';
import { CityInfoModel, ListSourceModel, OrderModel, RoomInfoModel, VoucherDetailModel } from 'models/order';
import { MyTextInput } from 'components/Input';
import { PopupPrintfAction } from 'components/popup-print/types';
import QrScanCode from 'components/QrScan';
import { toast } from 'react-toastify';
import { Container, Row, Col } from 'react-bootstrap';
import PopupDiscount from '../popup-discount';
import { PopupDiscountActions } from '../popup-discount/types';
import { IQrCode, ParamsOrder, ParamsOrderCheckBox } from '../types';
import { TextFieldActions } from 'components/Input/types';
import PopupQrCode, { ModalAction } from '../popup-qr';
import axios from 'axios';
import PopupUnpaidOrder from 'components/PopupOrderUnpaid';
import { useNavigate } from 'react-router-dom';
import printService from 'components/PopupPrintfOder/printService';
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};

const optionData = [
    {
        id: 1,
        label: 'Payment Direct',
        key: TYPE_SOURCE.PAYMENT_METHOD
    },
    {
        id: 5,
        label: 'QR Pay',
        key: TYPE_SOURCE.QR_PAY
    },
    {
        id: 3,
        label: 'Post to Room',
        key: TYPE_SOURCE.BUILDING
    },
    {
        id: 2,
        label: 'City Ledger',
        key: TYPE_SOURCE.CITY_LEDGER
    },
    {
        id: 4,
        label: 'FOC',
        key: TYPE_SOURCE.FOC
    }
];


const convertData = (_data: ListSourceModel[]) => {
    const convert = [] as TableDropDown[];
    _data?.map(item => convert.push({ id: item.value, value: item.text }));
    return convert;
};

type ValueTotal = {
    name: string;
    value: number;
}
const defaultInfo = {
    room: '',
    city: '',
    building: '',
    foc: '',
    hod: ''
};

const defaultListDrops = {
    city: [],
    room: [],
    building: [],
    foc: [],
    hoc: []
};

export const BASE_URL = 'https://kb.mandalahotel.com.vn/';

const PopupPayment = forwardRef<PopupPaymentActions, PopupPaymentProps>(({ title, onPressConfirm, setOpenModalPrint }: PopupPaymentProps, ref) => {
    let navigate = useNavigate();
    const [open, setOpen] = useState<boolean>(false);
    const [toggle, setToggle] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [disable, setDisable] = useState<boolean>(false);
    const [disableDiscount, setDisableDiscount] = useState<boolean>(false);
    const [errDrops, setErrDrops] = useState({ foc: false, building: false, city: false, room: false });
    const _user = localStorage.getItem('Apec_Account');
    const user = _user && JSON.parse(_user);
    const [option, setOption] = useState<Number>(1);
    const [voucherList, setVoucherList] = useState<VoucherDetailModel[] | null>([]);
    const [selectVoucher, setSelectVoucher] = useState<VoucherDetailModel>();
    const [dataVoucher, setDataVoucher] = useState<VoucherDetailModel>();
    const [dropsDown, setDropDown] = useState<TableDropDown[]>([]);
    const [errVoucher, setErrVoucher] = useState<string>('');
    const [customer, setDefaultCustomer] = useState<string>('');
    const [data, setData] = useState<OrderModel>();
    const [listDrops, setListDrops] = useState<ListDropsDown>(defaultListDrops);
    const [cityInfo, setCityInfo] = useState<CityInfoModel>();
    const [roomInfo, setRoomInfo] = useState<RoomInfoModel>();
    const [info, setInfo] = useState(defaultInfo);
    const [voucher, setVoucher] = useState<string>('');
    const [valueVoucher, setValueVoucher] = useState<string>('');
    const [valueTotalVoucher, setValueTotalVoucher] = useState<ValueTotal[]>([]);

    const defaultParams = {
        orderId: 0,
        paymentOption: 1,
        paymentMethod: 1,
        cardNo: '',
        cardHolder: '',
        receiptNo: '',
        focCode: undefined,
        remark: '',
        hodCode: '',
        cityledgerId: 0,
        roomId: 0,
        building: '',
        voucherNo: '',
        username: user?.username,
        customer: ''
    };
    const [params, setParams] = useState<ParamsPayment>(defaultParams);
    const defaultParamsCheckBox = {
        cash: true,
        card: false,
        bank: false
    };
    const [paramsCheckBox, setParamsCheckBox] = useState(defaultParamsCheckBox);
    const defaultDiscount = {
        isPercent: false,
        valueDiscount: 0,
        orderId: 0,
        username: user.username
    };
    const [paramsDiscount, setParamsDiscount] = useState<ParamsOrder>(defaultDiscount);
    const [extemp, setExtemp] = useState<ParamsOrderCheckBox>();
    const [qrCode, setQrCode] = useState<IQrCode>();
    const refFOC = useRef(null);
    const refCity = useRef(null);
    const refBuilding = useRef(null);
    const refRoom = useRef(null);
    const refPopupUnpaid = useRef<any>(null);
    const refModalDiscount = useRef<PopupDiscountActions>(null);
    const refText = useRef<TextAreaActions>(null);
    const refQrScan = useRef<PopupPrintfAction>(null);
    const refQrCode = useRef<ModalAction>(null);
    const refValueVoucher = useRef<TextFieldActions>(null);
    const refValueDiscount = useRef<TextFieldActions>(null);
    const showModal = async (id: string | number) => {
        clearVoucher();
        clearData();
        setOpen(true);
        getOderDetail(`${id}`);
        await Promise.all([
            getListSource(TYPE_SOURCE.CITY_LEDGER),
            getListSource(TYPE_SOURCE.PAYMENT_METHOD),
            getListSource(TYPE_SOURCE.BUILDING),
            getListSource(TYPE_SOURCE.FOC),
            getListSource(TYPE_SOURCE.HOC)
        ]);
    };

    const hideModal = () => {
        setInfo({
            room: '',
            city: '',
            building: '',
            foc: '',
            hod: ''
        });
        setParamsCheckBox(defaultParamsCheckBox);
        setVoucher('');
        setValueVoucher('');
        setValueTotalVoucher([]);
        setSelectVoucher(null as any);
        setDataVoucher(null as any);
        setVoucherList([]);
        setDropDown([]);
        setDefaultCustomer('');
        setParams({
            orderId: data?.orderId,
            ...defaultParams
        });
        setRoomInfo(null);
        setCityInfo(null);
        refValueVoucher.current?.setErrorMsg('');
        setParamsDiscount(defaultDiscount);
        setListDrops({
            city: [],
            room: [],
            building: [],
            foc: [],
            hoc: []
        });
        refCity.current?.setErr(false);
        refBuilding.current?.setErr(false);
        refFOC.current?.setErr(false);
        refRoom.current?.setErr(false);
        setErrDrops({ foc: false, building: false, city: false, room: false });
        setOption(1);
        setOpen(false);
    };

    const clearData = () => {
        setParamsCheckBox(defaultParamsCheckBox);
        setVoucher('');
        setValueVoucher('');
        setValueTotalVoucher([]);
        setSelectVoucher(null as any);
        setDataVoucher(null as any);
        setVoucherList([]);
        setDropDown([]);
        setDefaultCustomer('');
        setParams({
            orderId: data?.orderId,
            ...defaultParams
        });
        setRoomInfo(null);
        setCityInfo(null);
        setInfo({
            room: '',
            city: '',
            building: '',
            foc: '',
            hod: ''
        });
        refValueVoucher.current?.setErrorMsg('');
        setParamsDiscount(defaultDiscount);
        setListDrops({
            city: [],
            room: [],
            building: [],
            foc: [],
            hoc: []
        });
        refCity.current?.setErr(false);
        refBuilding.current?.setErr(false);
        refFOC.current?.setErr(false);
        refRoom.current?.setErr(false);
        setErrDrops({ foc: false, building: false, city: false, room: false });
        setOption(1);
    };

    const clearVoucher = async (code = '') => {
        await removeVoucher(data?.orderId || 0, code);
    };

    const onValidateVoucher = (_data) => {

        if (_data?.discount === 0) {
            refValueVoucher.current?.setErrorMsg(``);
            return;
        }
        console.log('valueTotalVoucher ==', valueTotalVoucher);

        if (!valueTotalVoucher || valueTotalVoucher?.length === 0) return;
        const _totalVoucher = valueTotalVoucher?.reduce((a, b) => a + Number(b.value), 0);
        const isVerify = _data.total - _totalVoucher === 0;
        console.log('isVerify', isVerify);

        if (isVerify) return;
        else {
            refValueVoucher.current?.setErrorMsg(`The order is discounted. You can't use an E-voucher worth less than the amount due.`);
            return;
        }
    };

    const getOderDetail = useCallback(async (id?: string) => {
        if (id) {
            setLoading(true);
            const res = await fetchOrderDetail(id);
            setLoading(false);
            if (res.message === 'Success') {
                const _data = res.metadata[0] as OrderModel;
                const defaultExtemp = {
                    isSVC: _data?.extempSVC === TYPE_EXTEMP.YES,
                    isVAT: _data?.extempVAT === TYPE_EXTEMP.YES,
                    orderId: Number(_data?.orderId || 0),
                    username: user.username
                };
                setParamsDiscount({
                    isPercent: _data.isDiscountPer === 'Y',
                    valueDiscount: Number(_data?.discount || 0),
                    orderId: _data?.orderId || 0,
                    username: user.username
                });
                setParams({
                    ...params,
                    orderId: _data?.orderId || 0,
                });
                setData(_data);
                setExtemp(defaultExtemp);
                // onValidateVoucher(_data);
                // if (Number(_data?.discount || 0) > 0) setDisableVoucher(true);
                // else setDisableVoucher(false);
            } else {
                toast.error(Language.err.notFound, {
                    position: 'top-right',
                    theme: 'colored'
                });
            }
        }
    }, []);

    const getListRoom = useCallback(async (item: TableDropDown) => {
        setParams(last => {
            last.building = item.id.toString();
            return last;
        });
        setInfo(
            last => {
                last.building = item.value;
                return last;
            }
        );
        setErrDrops(last => {
            last.building = false;
            return last;
        });
        setToggle(last => !last);
        setLoading(true);
        const res = await fetchListRoom(item.id);
        setLoading(false);
        if (res.message === 'Success') {
            const _list = res.metadata as ListSourceModel[];
            return setListDrops(last => {
                last.room = convertData(_list);
                return last;
            });
        }
    }, []);

    const getListSource = useCallback(async (id) => {
        setLoading(true);
        const res = await fetchListSource(id);
        setLoading(false);

        if (res.message === 'Success') {
            const _list = res.metadata as ListSourceModel[];
            switch (id) {
                case TYPE_SOURCE.PAYMENT_METHOD:
                    return;
                case TYPE_SOURCE.CITY_LEDGER:
                    return setListDrops(last => {
                        last.city = convertData(_list);
                        return last;
                    });
                case TYPE_SOURCE.BUILDING:
                    return setListDrops(last => {
                        last.building = convertData(_list);
                        return last;
                    });
                case TYPE_SOURCE.FOC:
                    return setListDrops(last => {
                        last.foc = convertData(_list);
                        return last;
                    });
                case TYPE_SOURCE.HOC:
                    return setListDrops(last => {
                        last.hoc = convertData(_list);
                        return last;
                    });
                default:
                    return;
            }
        }
    }, []);

    const onExtemp = useCallback(async (paramsExtemp: ParamsOrderCheckBox) => {
        const _params = { ...paramsExtemp, orderId: data?.orderId } as ParamsOrderCheckBox;
        const resExtemp = await fetchUpdateUpdateVATAndSVC(_params);
        setLoading(false);
        if (resExtemp.message === 'Success') {
            setExtemp(paramsExtemp);
            setExtemp({ ...extemp, isSVC: !extemp.isSVC });
            getOderDetail(`${data?.orderId}`);
        } else {
            toast.error(`${resExtemp?.message}` || Language.toast.payment.errUpdate, {
                position: 'top-right',
                theme: 'colored'
            });
        }
    }, [data]);

    const onEditDiscountOrder = useCallback(async (paramsOrder: ParamsOrder) => {
        setLoading(true);
        const _params = { ...paramsOrder, orderId: data?.orderId } as ParamsOrder;

        const res = await fetchUpdateDiscountOrder(_params);
        setLoading(false);
        if (res.message === 'Success') {
            getOderDetail(`${data?.orderId}`);
        } else {
            toast.error(`${res?.message}` || Language.toast.payment.errUpdate, {
                position: 'top-right',
                theme: 'colored'
            });
        }
    }, [data?.orderId, valueTotalVoucher]);

    const onValidateDiscount = (discount: string | number) => {
        // if (Number(discount) > data.subAmount) {
        //     refValueDiscount.current?.setErrorMsg('Số tiền Discount phải nhỏ hơn Amount.');
        //     return false;
        // }
        return true;
    };

    const onUpdateDiscount = (discount) => {
        if (onValidateDiscount(Number(discount || 0))) {
            setParamsDiscount(last => {
                last.valueDiscount = Number(discount);
                onEditDiscountOrder?.(last);
                return last;
            }
            );
        }
    };

    const onChangePercent = () => {
        setParamsDiscount(last => {
            last.isPercent = !last.isPercent;
            last.valueDiscount = Number(last.valueDiscount) > 100 ? 100 : last.valueDiscount;
            onEditDiscountOrder?.(last);
            return last;
        });
    };

    const getVoucher = useCallback(async (value: string, valueVoucherApplied?: string, reset?: boolean) => {
        if (value && value.length > 0) {
            const _valueVoucherApplied = valueVoucherApplied ? valueVoucherApplied : valueVoucher;
            setLoading(true);
            const res = await fetchVoucher(value, data?.orderId, reset ? '0' : _valueVoucherApplied);
            setLoading(false);

            if (res?.message === 'Success') {
                const _data = res.metadata[0] as VoucherDetailModel;
                _data.voucherCode = value;

                const sales = [] as TableDropDown[];
                res.metadata[0]?.listCustomer?.map(item => sales.push({ id: item?.value, value: item?.text.split(' - ')[0] }));
                const total = Number(data?.total || 0);
                const valuept = Number(_data?.valuept || 0);
                const voucherValueRemain = Number(_data?.voucherValueRemain || 0);
                const _valueRemainForPercent =
                    _data?.valueType === VoucherType.PERCENT
                        ? (valuept * total) / 100
                        : Number(voucherValueRemain);
                if (maxVoucher(_data.voucherCode) === 0) return;
                if (_data?.valueType === VoucherType.PERCENT) setDisableDiscount(true);
                else setDisableDiscount(false);
                const _maxValueRemainForPercent = Math.min(_valueRemainForPercent, maxVoucher(value));
                if (voucherList && voucherList.some((e: VoucherDetailModel) => String(e.voucherCode?.trim()) === String(value))) {
                    if (reset) {
                        refValueVoucher?.current?.setValue(`${Math.ceil(_maxValueRemainForPercent || 0)}`);
                    }
                    if (_valueVoucherApplied && Number(_valueVoucherApplied) > 0) {
                        setValueTotalVoucher((prevItems) =>
                            prevItems.map((item) =>
                                item.name === value
                                    ? { ...item, value: Number(_valueVoucherApplied || 0) }
                                    : item
                            )
                        );
                    }
                    if (reset) {
                        setValueTotalVoucher((prevItems) =>
                            prevItems.map((item) =>
                                item.name === value
                                    ? { ...item, value: Number(_maxValueRemainForPercent || 0) }
                                    : item
                            )
                        );
                    }
                    return;
                }
                setValueTotalVoucher((pre) => pre.concat([{ name: _data.voucherCode, value: _valueVoucherApplied ? Number(_valueVoucherApplied || 0) : Number(_maxValueRemainForPercent || 0) }]));

                refValueVoucher?.current?.setValue(`${Math.ceil(_maxValueRemainForPercent || 0)}`);
                setDropDown(sales);
                if (sales && sales?.length > 0) setDefaultCustomer(sales?.[0]?.value || '');
                else setDefaultCustomer('');
                setVoucherList([...voucherList || [], ...[_data]]);
                if (res.metadata?.length === 0) {
                    setErrVoucher(Language.payment.errVoucher);
                }
                setDataVoucher(_data);
                // if (Number(data?.discount || 0) > 0 && _valueRemainForPercent < maxVoucher(value)) {
                //     refValueVoucher.current?.setErrorMsg(`The order is discounted. You can't use an E-voucher worth less than the amount due.`);
                //     return;
                // }
            } else {
                setVoucherList([...voucherList]);
                toast.error(`${res?.message}` || Language.err.notFound, {
                    position: 'top-right',
                    theme: 'colored'
                });
            }
            setLoading(false);
        } else {
            setVoucherList([...voucherList]);
        }
    }, [data, voucherList, valueVoucher]);

    const onPayment = async (_params) => {
        setLoading(true);
        const res = await fetchPayment(_params);
        setLoading(false);
        if (res.message === 'Success') {
            const print = await fetchInfoPrintOrder(_params?.orderId);
            if (print.message === 'Success') {
                const _data = print.metadata[0] as any;
                await printService(_data);
            }
            onPressConfirm?.();
            clearData();
            hideModal();
        } else {
            if (res?.message && res?.message?.includes('Order trên đã thanh toán')) {
                return refPopupUnpaid?.current?.showModal(res?.message || 'Update order error');
            } else {
                toast.error(res.message || Language.err.paymentErr, {
                    position: 'top-right',
                    theme: 'colored'
                });
            }
        }
    };

    const onConfirm = () => {
        if (params.paymentOption === OptionPaymentType.FOC && !params?.focCode) {
            refFOC.current?.setErr(!params.focCode);
            setErrDrops(last => {
                last.foc = !params.focCode;
                return last;
            });
            setToggle(last => !last);
            return;
        }

        if (params.paymentOption === OptionPaymentType.CITY_LEDGER && !params?.cityledgerId) {
            refCity.current?.setErr(!params.cityledgerId);
            setErrDrops(last => {
                last.city = !params.cityledgerId;
                return last;
            });
            setToggle(last => !last);
            return;
        }
        console.log('params', params);

        if (params.paymentOption === OptionPaymentType.POST_TO_ROOM && (!params?.building || !params.roomId)) {
            if (!params.building && !params.roomId) {
                refBuilding.current?.setErr(!params.building);
                refRoom.current?.setErr(!params.roomId);
            } else {
                if (!params.building) refBuilding.current?.setErr(!params.building);
                if (!params.roomId) refRoom.current?.setErr(!params.roomId);
            }
            setErrDrops(last => {
                last.building = !params.building;
                last.room = !params.roomId;
                return last;
            });
            setToggle(last => !last);
            return;
        }

        setParams(last => {
            last.remark = refText.current.getValue() || '';
            last.voucherNo = voucherList && voucherList?.length > 0 ? voucherList?.[0]?.voucherCode : "";
            last.customer = last?.customer ? last?.customer : customer;
            onPayment?.(last);
            return last;
        });
    };

    const onNavigateOrderPaid = () => {
        navigate('/order-paid');
    };

    useImperativeHandle(ref, () => ({
        showModal,
        hideModal,
        clearData
    }));

    const setCheckBox = (value: boolean, label: string) => {
        if (label === Language.payment.popupPayment.cash) {
            setParamsCheckBox({ ...paramsCheckBox, cash: value, card: false, bank: false });
            setParams(last => {
                last.paymentMethod = 1;
                return last;
            });
        } else if (label === Language.payment.popupPayment.card) {
            setParamsCheckBox({ ...paramsCheckBox, card: value, cash: false, bank: false });
            setParams(last => {
                last.paymentMethod = 2;
                return last;
            });
        } else {
            setParams(last => {
                last.paymentMethod = 3;
                return last;
            });
            setParamsCheckBox({ ...paramsCheckBox, bank: value, card: false, cash: false });
        }
    };

    const setOptionExtamp = (value: boolean, label: string) => {
        if (label === Language.orderPaid.svc) {
            const _extemp = { ...extemp, isSVC: !extemp.isSVC };
            onExtemp(_extemp);
        } else {
            const _extemp = { ...extemp, isVAT: !extemp.isVAT };
            onExtemp(_extemp);
        }
    };


    const onChooseFOC = useCallback((item: TableDropDown) => {
        setParams(last => {
            last.focCode = Number(item.id);
            return last;
        });
        setInfo(
            last => {
                last.foc = item.value;
                return last;
            }
        );
        setErrDrops(last => {
            last.foc = false;
            return last;
        });
        setToggle(last => !last);
    }, []);

    const onChooseHOD = useCallback((item: TableDropDown) => {
        setParams(last => {
            last.hodCode = item.id;
            return last;
        });
        setInfo(
            last => {
                last.hod = item.value;
                return last;
            }
        );

    }, []);

    const onGetInfoCity = useCallback(async (item: TableDropDown) => {
        setParams(last => {
            last.cityledgerId = Number(item.id);
            return last;
        });
        setInfo(
            last => {
                last.city = item.value;
                return last;
            }
        );
        setLoading(true);
        const res = await fetchCityInfo(item.id);
        setLoading(false);
        if (res.message === 'Success') {
            const _data = res.metadata[0] as CityInfoModel;
            setCityInfo(_data);
        }
    }, []);

    const onGetRoomInfo = useCallback(async (item: TableDropDown) => {
        console.log('onGetRoomInfo');

        setParams(last => {
            last.roomId = Number(item.id);
            return last;
        });
        setInfo(
            last => {
                last.room = item.value;
                return last;
            }
        );
        setLoading(true);
        const res = await fetchRoomInfo(item.id);
        setLoading(false);
        if (res.message === 'Success') {
            refRoom.current?.setErr(false);
            const _data = res.metadata[0] as RoomInfoModel;
            setRoomInfo(_data);
            setErrDrops(last => {
                last.room = false;
                return last;
            });
        }
    }, []);

    const viewText = (label: string, value: string, styleContainer?: any, color?: string) => {
        return (
            <div className={`body-city-item ${styleContainer}`}>
                <span className='text-normal color-text-2 regular space-nowrap'>{label}</span>
                <span className={`text-normal color-black bold space-nowrap ${color}`}>{value}</span>
            </div>
        );
    };

    const renderDropDown = useCallback((label: string, arr: TableDropDown[], onPressDrops: any, value?: string, refDropDown?: any, err?: boolean) => {
        return (
            <div className='flex-row center' style={{ border: err ? '1px solid red' : 'none', marginBottom: 5, borderRadius: 5, padding: '0px 5px' }}>
                <span className='text-normal color-gray regular space-nowrap'>{label}</span>
                <DropDownComponent
                    ref={refDropDown}
                    data={arr}
                    isSearch
                    label={Language.payment.choose}
                    styleLabel={'text-normal color-black bold space-nowrap mgr-24'}
                    stylesContainer={'drops-down-customer'}
                    defaultValue={value}
                    onPress={onPressDrops}
                    iconRight={<SVGUpDown />}
                    styleIconRight={'discount-icon-right'}
                    widthMenu={400}
                />
            </div>
        );
    }, []);

    const viewPaymentDirec = useMemo(() => {
        return (
            <div className='payment-direc'>
                <CheckBox
                    listOption={paramsCheckBox?.cash || false}
                    setListOption={setCheckBox}
                    item={{ id: 1, name: Language.payment.popupPayment.cash }}
                    styles={'mgb-10'}
                    icon={<SVGCash />}
                    typeCheck
                />
                <CheckBox
                    listOption={paramsCheckBox?.card || false}
                    setListOption={setCheckBox}
                    item={{ id: 2, name: Language.payment.popupPayment.card }}
                    styles={'mgb-10'}
                    icon={<SVGCardPayment />}
                    typeCheck
                />
                <CheckBox
                    listOption={paramsCheckBox?.bank || false}
                    setListOption={setCheckBox}
                    item={{ id: 3, name: Language.payment.popupPayment.bank }}
                    styles={'mgb-10'}
                    icon={<SVGBank />}
                    typeCheck
                />
            </div>
        );
    }, [paramsCheckBox?.bank, paramsCheckBox?.card, paramsCheckBox?.cash, setCheckBox]);

    const viewCityLedger = useMemo(() => {
        return (
            <div className='city-ledger'>
                {renderDropDown(`${Language.payment.popupPayment.cityLedger}:`, listDrops.city, onGetInfoCity, info.city, refCity, errDrops.city)}
                <div className='body-city'>
                    {viewText(Language.payment.popupPayment.limit, Format.formatMoneyNumber(cityInfo?.limit || 0), 'mgb-16')}
                    {viewText(Language.payment.popupPayment.tern, cityInfo?.term.toString())}
                </div>
            </div>
        );
    }, [listDrops.city, cityInfo, info.city, errDrops.city, toggle]);

    const viewPostToRoom = () => {
        console.log('info', info);

        return (
            <div className='city-ledger'>
                <div className='building-view'>
                    {renderDropDown(`${Language.payment.popupPayment.building}:`, listDrops.building, getListRoom, info?.building, refBuilding, errDrops.building)}
                    {renderDropDown(`${Language.payment.popupPayment.room}:`, listDrops.room, onGetRoomInfo, info?.room, refRoom, errDrops.room)}
                </div>
                <div className='body-city'>
                    {viewText(Language.payment.popupPayment.folio, roomInfo?.roomCode || '', 'mgb-16')}
                    {viewText(Language.payment.popupPayment.guestName, roomInfo?.guestName || '', 'mgb-16')}
                    {viewText(Language.payment.popupPayment.room, roomInfo?.folioNo || '')}
                </div>
            </div>
        );
    };

    const viewFOC = useMemo(() => {

        return (
            <div className='city-ledger'>
                <div className='building-view'>
                    {renderDropDown(`${Language.payment.popupPayment.focType}:`, listDrops.foc, onChooseFOC, info.foc, refFOC, errDrops.foc)}
                    {renderDropDown(`${Language.payment.popupPayment.HODFOC}:`, listDrops.hoc, onChooseHOD, info.hod)}
                </div>
                <div className='building-view'>
                    {renderDropDown(`${Language.payment.popupPayment.building}:`, listDrops.building, getListRoom, info.building)}
                    {renderDropDown(`${Language.payment.popupPayment.room}:`, listDrops.room, onGetRoomInfo, info.room)}
                </div>
            </div>
        );
    }, [listDrops.hoc, listDrops.foc, listDrops.room, listDrops.building, info.building, info.room, info.foc, info.hod, errDrops.foc, toggle]);

    const renderOptionChild = useMemo(() => {
        switch (option) {
            case OptionPaymentType.PAYMENT_DIREC:
                return viewPaymentDirec;
            case OptionPaymentType.CITY_LEDGER:
                return viewCityLedger;
            case OptionPaymentType.POST_TO_ROOM:
                return viewPostToRoom();
            case OptionPaymentType.FOC:
                return viewFOC;
            default:
                return;
        }
    }, [option, viewCityLedger, viewFOC, viewPaymentDirec, viewPostToRoom, info, roomInfo, toggle]);

    const getQrCode = async () => {
        setLoading(true);
        let _totalValueVoucher = valueTotalVoucher?.reduce((a, b) => a + Number(b.value || 0), 0);

        const body = {
            orderNo: data?.orderNo || '',
            amount: `${Number(data?.total || 0) - Number(_totalValueVoucher || 0)}`
        };
        try {
            const response = await axios.post(`${BASE_URL}${enpoint.ORDER.GEN_QR_CODE}`, body);
            setQrCode(response.data);
            refQrCode.current.showModal(response.data);
            setLoading(false);
            console.log('Data:', response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);

        }
    };

    const renderViewOption = () => {
        const _totalVoucher = valueTotalVoucher?.reduce((a, b) => a + Number(b.value), 0);
        const isDisable = Number(_totalVoucher || 0) > 0 && (Number(data?.total || 0) - _totalVoucher) <= 0;
        // console.log('valueTotalVoucher', valueTotalVoucher);

        return (
            <div className='option border' style={{ pointerEvents: isDisable ? 'none' : 'auto', opacity: isDisable ? 0.5 : 1 }}>
                <span className='text-big medium color-black'>{Language.payment.popupPayment.optionPayment}</span>
                <div className='view-item'>
                    {optionData.map((item, index) => {
                        const onChangeOption = async () => {
                            if (Number(item.id) === 5) {
                                return getQrCode();
                            }
                            setParams(last => {
                                last.paymentOption = item.id;
                                if (item.id !== OptionPaymentType.PAYMENT_DIREC) {
                                    last.paymentMethod = 1;
                                }
                                return last;
                            });
                            setOption(item.id);

                        };

                        return (
                            <div key={index} className={`item-option ${option === item.id ? 'border-active' : 'border-blur'}`} onClick={onChangeOption} >
                                {option === item.id && <div className='ic-option'>
                                    <SVGCheckActive />
                                </div>}
                                <span className={` space-nowrap text-normal bold  ${option === item.id ? 'color-brown' : 'color-black'}`}>{item.label}</span>
                            </div>
                        );
                    })}

                </div>
                <div className='option-child'>
                    {renderOptionChild}
                </div>
            </div>
        );
    };

    const renderRemarks = useMemo(() => {
        return (
            <div className='option border'>
                <MyTextAreaInput
                    label={Language.payment.popupPayment.remarks}
                    placeHolder={Language.payment.popupPayment.placeHolder}
                    labelStyles='mgb-10'
                    inputStyle='input-remark'
                    value={''}
                    onChangeText={(text) => setParams({ ...params, remark: text || '' })}
                    ref={refText}
                />
            </div>
        );
    }, [params]);

    const onCamera = () => {
        refQrScan.current.showModal();
    };

    const onQrCode = (value: any) => {
        if (value?.text && value?.text.length > 0) {
            getVoucher(value?.text);
        }
    };

    const onChangeText = (text) => {
        setVoucher(text || '');
    };


    const maxVoucher = (no: string) => {
        return Number(data?.total || 0) - valueTotalVoucher?.filter((e: ValueTotal) => e.name !== no).reduce((a, b) => a + Number(b.value), 0);
    };

    const onChangeTextValue = (text) => {
        setValueVoucher(text || '');
    };

    const onBlurVoucherValue = (text) => {
        const { voucherCode } = dataVoucher || {};
        const _valueRemainForPercent = Number(text || 0);
        // if (data.discount > 0 && _valueRemainForPercent !== maxVoucher(voucherCode)) return refValueVoucher.current?.setErrorMsg(`The order is discounted. You can't use an E-voucher worth less than the amount due.`);
        if (_valueRemainForPercent > maxVoucher(voucherCode)) {
            setDisable(true);
            return refValueVoucher.current?.setErrorMsg(`The voucher value cannot exceed the bill amount.`);
        } else {
            setDisable(false);
            getVoucher(voucherCode, text);
        }
        // getVoucher(voucherCode);
        // setValueTotalVoucher((prevItems) =>
        //     prevItems.map((item) =>
        //         item.name === voucherCode
        //             ? { ...item, value: _valueRemainForPercent }
        //             : item
        //     )
        // );
    };

    const onChooseCustomer = async (item: TableDropDown) => {
        setDefaultCustomer(item?.value);
        try {
            const res: any = await axios.post(`${BASE_URL}${enpoint.ORDER.UPDATE_PAYER}`, {
                orderId: data?.orderId,
                voucherCode: dataVoucher.voucherCode,
                customerList: item?.value
            });
            if (res?.status !== 200) {
                toast.error(`${res?.data?.message}` || Language.err.notFound, {
                    position: 'top-right',
                    theme: 'colored'
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setParams(last => {
            last.customer = item?.value || '';
            return last;
        });
    };

    const renderVoucher = () => {
        const totalVoucher = valueTotalVoucher?.length < 1 ? 0 : valueTotalVoucher?.reduce((a, b) => a + Number(b.value || 0), 0);

        return (
            <div className='option border'>
                <div className='flex-row body-city-item'>
                    <div className='text-big medium color-black'>Voucher info</div>
                    <div className='text-normal color-neu medium flex-row'>Table No:<div
                        style={{ color: '#047D46', marginLeft: 8 }}
                    >{data?.tableCode || ''}</div></div>
                </div>
                <div className="flex-row" style={{ gap: 16 }}>
                    <MyTextInput
                        type={TYPE_INPUT.TEXT}
                        containerInput={'input-discount-payment width-30 border'}
                        placeHolder={Language.payment.enterValue}
                        containerStyle={'container-my-input'}
                        value={''}
                        onChangeText={onChangeText}
                    />
                    <div className="camera-box" onClick={onCamera}>
                        <SVGQrCode />
                    </div>
                    <MyButton label={`Apply`} styleContainer={'btn-pay-apply'} onPress={() => getVoucher(voucher, '', true)} />
                </div>
                <div className='text-normal medium color-neu '
                    style={{ pointerEvents: dataVoucher?.valueType === VoucherType.PERCENT ? 'none' : 'auto', opacity: dataVoucher?.valueType === VoucherType.PERCENT ? 0.5 : 1 }}>Amount</div>
                <MyTextInput
                    ref={refValueVoucher}
                    type={TYPE_INPUT.TEXT}
                    value={''}
                    containerInput={'input-discount-payment width-30 border'}
                    placeHolder={Language.payment.enterValue}
                    containerStyle={'container-my-input'}
                    onChangeText={onChangeTextValue}
                    onBlurText={onBlurVoucherValue}
                />

                {voucher && voucher?.length > 0 && dropsDown && dropsDown?.length > 0 && <div className='flex-row body-city-item center border-bottom'>
                    <div className='text-normal medium color-neu '>Payer</div>
                    <div className='jus-between'>
                        <DropDownComponent
                            data={dropsDown}
                            label={Language.payment.choose}
                            styleLabel={'text-normal color-black bold space-nowrap mgr-24'}
                            stylesContainer={'drops-down-customer'}
                            defaultValue={`${customer}` || `${dropsDown[0]?.value}`}
                            onPress={onChooseCustomer}
                            iconRight={<SVGDown />}
                            styleIconRight={'discount-icon-right'}
                            stylesDrops={'width-100'}
                        />
                    </div>
                </div>}
                {voucherList && voucherList?.length > 0 && <div className='jus-between center'>
                    <div className='text-normal medium color-neu '>Total Voucher</div>
                    <div className='text-big color-black bold'>{Format.formatMoney(totalVoucher || 0)}</div>
                </div>
                }
                {voucherList && voucherList?.length > 0 && <div className='list-voucher'>
                    <div className='text-big medium color-black'>Voucher list ({voucherList.length || 0})</div>
                    <div className='scroll-list'>
                        <Container style={{ padding: 0 }}>
                            <div style={{ gap: 12, rowGap: 12, flexDirection: 'row', flexWrap: 'wrap', display: 'flex' }}>
                                {voucherList && voucherList.length > 0 && voucherList?.map((item: VoucherDetailModel, index: number) => {
                                    const onShowDetailVoucher = () => {
                                        refModalDiscount?.current?.showModal();
                                        setSelectVoucher(item);
                                    };

                                    const deleteVoucher = () => {
                                        setVoucherList(voucherList?.filter((e: VoucherDetailModel) => item.voucherCode !== e?.voucherCode));
                                        setValueTotalVoucher(valueTotalVoucher?.filter((e: ValueTotal) => item.voucherCode !== e?.name));
                                        if (valueTotalVoucher?.filter((e: ValueTotal) => item.voucherCode !== e?.name)?.length === 0) setDisableDiscount(false);
                                        if (item.voucherCode === dataVoucher.voucherCode) {
                                            refValueVoucher?.current?.setValue('');
                                        }
                                        clearVoucher(item?.voucherCode || '');
                                    };

                                    return (
                                        <div key={index} className='item-vc text-small medium color-black' >
                                            <div onClick={onShowDetailVoucher}>{item?.voucherCode || ''}</div>
                                            <div onClick={deleteVoucher}><SVGCancelPayment /></div>
                                        </div>
                                    );
                                })}
                            </div>
                        </Container>
                    </div>
                </div>
                }

            </div>
        );
    };

    const renderPaymentDetail = useMemo(() => {
        const _totalValueVoucher = valueTotalVoucher?.reduce((a, b) => a + Number(b.value || 0), 0);
        return (
            <div className='payment-detail-view border border-blur' >
                <div className="text-big medium color-black mgb-10">Payment Detail</div>
                {viewText(`${Language.orderPaid.amount} ( ${data?.items?.length || 0} items ) `, Format.formatMoney(data?.amountNet), 'mgb-16')}
                {viewText(`${Language.orderPaid.vat}`, Format.formatMoney(data?.vat), 'mgb-16')}
                {viewText(`${Language.orderPaid.svc}`, Format.formatMoney(data?.svc), 'mgb-16')}
                {viewText(`TTDB`, Format.formatMoney(data?.ttdb), 'mgb-16')}
                {viewText(`${Language.orderPaid.billDiscount}`, `- ${Format.formatMoney(data?.totalDiscount)}`, 'mgb-16', 'color-yellow')}
                <div className='line' />
                <div className='body-city-item mgt-16'>
                    <span className='text-normal color-black bold space-nowrap'>{Language.orderPaid.total}</span>
                    <span className='text-normal color-red bold space-nowrap'>{Format.formatMoney(data?.total)}</span>
                </div>
                {valueTotalVoucher && valueTotalVoucher?.length > 0 && viewText(`${Language.orderPaid.voucherDiscount}`, `- ${Format.formatMoney(_totalValueVoucher || 0)}`, 'mgb-16 mgt-16', 'color-yellow')}
            </div>
        );
    }, [data, valueTotalVoucher]);

    const renderDiscount = () => {
        return (
            <div className='option border'>
                <div className="body-city-item">
                    <div className="label-checkbox">
                        Discount info
                    </div>
                    <div className="row-checkbox">
                        <CheckBox listOption={extemp?.isSVC || false} setListOption={setOptionExtamp} item={{ id: 1, name: Language.orderPaid.svc }} />
                        <CheckBox listOption={extemp?.isVAT || false} setListOption={setOptionExtamp} item={{ id: 2, name: Language.orderPaid.vat }} />
                    </div>
                </div>
                <div className="body-city-item center" style={{ pointerEvents: disableDiscount ? 'none' : 'auto', opacity: disableDiscount ? 0.5 : 1 }}>
                    <MyTextInput
                        ref={refValueDiscount}
                        type={TYPE_INPUT.NUMBER}
                        containerInput={'input-discount-payment border'}
                        inputStyle={'input-style text-normal'}
                        placeHolder={Language.payment.enterValue}
                        isPercent={paramsDiscount.isPercent}
                        value={Number(data?.discount) > 0 ? data?.discount : undefined}
                        containerStyle={'container-my-input'}
                        onChangeText={(e) => setParamsDiscount(last => {
                            last.valueDiscount = Number(e || 0);
                            return last;
                        })}
                        // disabled={disableDiscount}
                        onBlurText={onUpdateDiscount}
                    />
                    <div className='row-percent center text-normal medium' onClick={onChangePercent}>
                        <CheckBox
                            listOption={paramsDiscount?.isPercent || false}
                        />
                        %
                    </div>
                </div>
            </div>
        );
    };

    // console.log('voucher list ===', voucherList);
    return (
        <Modal
            open={open}
            onClose={hideModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            onBackdropClick={hideModal}
        >
            <Box sx={style}>
                <div className='popup-payment'>
                    <div className="popup-container width-payment flex-1">
                        <div className="header-payment">
                            <div className="text-big-x bold color-black mgl-5">
                                {title || 'This is title'}:
                            </div>
                            <div className="text-big-x bold color-black mgl-5" style={{ color: '#A66C21' }}>{data?.orderNo || ''}</div>
                        </div>
                        <div className='body-popup-payment'>
                            <div className='payment-option'>
                                {renderVoucher()}
                                {renderRemarks}
                            </div>
                            <div className='payment-detail' >
                                {renderDiscount()}
                                {renderViewOption()}
                                {renderPaymentDetail}
                                <div style={{ width: '100%' }} >&nbsp;</div>

                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div className='btn-printf ' onClick={() => setOpenModalPrint(true)}>
                                <SVGPrintPayment /> {Language.payment.print}
                            </div>
                            <MyButton
                                label={`Total Amount Paid ${Format.formatMoney(data?.total - Number(valueTotalVoucher?.reduce((a, b) => a + Number(b.value || 0), 0) || 0))}`}
                                styleContainer={'btn-payment'} onPress={onConfirm} isDisable={disable} />
                        </div>
                    </div>

                </div>
                <QrScanCode ref={refQrScan} onConfirm={onQrCode} />
                {selectVoucher ? <PopupDiscount
                    ref={refModalDiscount}
                    title={Language.payment.voucherModal.title}
                    data={selectVoucher}
                    des={Language.payment.voucherModal.content}
                    dataDrop={dropsDown}
                    defaultDrop={dropsDown[0].value}
                /> : null}
                <PopupQrCode ref={refQrCode} onConfirm={() => console.log('close')} />
                {loading && <LoadingTable />}
                <PopupUnpaidOrder ref={refPopupUnpaid} onConfirm={onNavigateOrderPaid} />
            </Box>
        </Modal>
    );
});
export default PopupPayment;


const SVGDown = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.88137 4.62612C10.0464 4.46673 10.2674 4.37853 10.4968 4.38053C10.7263 4.38252 10.9457 4.47454 11.108 4.63678C11.2702 4.79901 11.3622 5.01847 11.3642 5.24789C11.3662 5.47731 11.278 5.69834 11.1186 5.86337L7.61862 9.36337C7.45453 9.5274 7.23201 9.61955 6.99999 9.61955C6.76797 9.61955 6.54545 9.5274 6.38137 9.36337L2.88137 5.86337C2.72198 5.69834 2.63378 5.47731 2.63578 5.24789C2.63777 5.01847 2.72979 4.79901 2.89202 4.63678C3.05426 4.47454 3.27372 4.38252 3.50314 4.38053C3.73256 4.37853 3.95359 4.46673 4.11861 4.62612L6.99999 7.50749L9.88137 4.62612Z" fill="#9C9C9E" />
        </svg>

    );
};

const SVGCancelPayment = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M2.05806 9.94194C1.81398 9.69786 1.81398 9.30214 2.05806 9.05806L9.05806 2.05806C9.30214 1.81398 9.69786 1.81398 9.94194 2.05806C10.186 2.30214 10.186 2.69786 9.94194 2.94194L2.94194 9.94194C2.69786 10.186 2.30214 10.186 2.05806 9.94194Z" fill="#9C9C9E" />
            <path fillRule="evenodd" clipRule="evenodd" d="M9.94194 9.94194C9.69786 10.186 9.30214 10.186 9.05806 9.94194L2.05806 2.94194C1.81398 2.69786 1.81398 2.30213 2.05806 2.05806C2.30214 1.81398 2.69786 1.81398 2.94194 2.05806L9.94194 9.05806C10.186 9.30214 10.186 9.69786 9.94194 9.94194Z" fill="#9C9C9E" />
        </svg>

    );
};

export const SVGPrintPayment = () => {
    return (
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.0024 6.24788V4.89715C15.0024 4.05662 15.0024 3.63635 14.8388 3.31531C14.6949 3.03291 14.4653 2.80332 14.1829 2.65943C13.8619 2.49585 13.4416 2.49585 12.6011 2.49585H8.39878C7.55824 2.49585 7.13798 2.49585 6.81694 2.65943C6.53454 2.80332 6.30494 3.03291 6.16106 3.31531C5.99748 3.63635 5.99748 4.05662 5.99748 4.89715V6.24788M5.99748 14.5024C5.29962 14.5024 4.95069 14.5024 4.66441 14.4257C3.88753 14.2175 3.28072 13.6107 3.07256 12.8338C2.99585 12.5475 2.99585 12.1986 2.99585 11.5007V9.84984C2.99585 8.58904 2.99585 7.95863 3.24122 7.47707C3.45705 7.05348 3.80144 6.70908 4.22504 6.49325C4.7066 6.24788 5.337 6.24788 6.5978 6.24788H14.402C15.6628 6.24788 16.2932 6.24788 16.7748 6.49325C17.1984 6.70908 17.5428 7.05348 17.7586 7.47707C18.004 7.95863 18.004 8.58904 18.004 9.84984V11.5007C18.004 12.1986 18.004 12.5475 17.9273 12.8338C17.7191 13.6107 17.1123 14.2175 16.3354 14.4257C16.0491 14.5024 15.7002 14.5024 15.0024 14.5024M12.7511 8.87431H15.0024M8.39878 17.504H12.6011C13.4416 17.504 13.8619 17.504 14.1829 17.3404C14.4653 17.1965 14.6949 16.9669 14.8388 16.6845C15.0024 16.3635 15.0024 15.9432 15.0024 15.1027V13.902C15.0024 13.0615 15.0024 12.6412 14.8388 12.3202C14.6949 12.0378 14.4653 11.8082 14.1829 11.6643C13.8619 11.5007 13.4416 11.5007 12.6011 11.5007H8.39878C7.55824 11.5007 7.13798 11.5007 6.81694 11.6643C6.53454 11.8082 6.30494 12.0378 6.16106 12.3202C5.99748 12.6412 5.99748 13.0615 5.99748 13.902V15.1027C5.99748 15.9432 5.99748 16.3635 6.16106 16.6845C6.30494 16.9669 6.53454 17.1965 6.81694 17.3404C7.13798 17.504 7.55824 17.504 8.39878 17.504Z" stroke="black" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

